module.exports = __webpack_public_path__ + "img/GVC002.b6aade70.png";